var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconAddSelectTree(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.99963 0C9.298 0 9.58415 0.118527 9.79513 0.329505C10.0061 0.540484 10.1246 0.826631 10.1246 1.125V7.875H16.8746C17.173 7.875 17.4592 7.99353 17.6701 8.2045C17.8811 8.41548 17.9996 8.70163 17.9996 9C17.9996 9.29837 17.8811 9.58452 17.6701 9.7955C17.4592 10.0065 17.173 10.125 16.8746 10.125H10.1246V16.875C10.1246 17.1734 10.0061 17.4595 9.79513 17.6705C9.58415 17.8815 9.298 18 8.99963 18C8.70127 18 8.41512 17.8815 8.20414 17.6705C7.99316 17.4595 7.87463 17.1734 7.87463 16.875V10.125H1.12463C0.826265 10.125 0.540117 10.0065 0.329139 9.7955C0.11816 9.58452 -0.000366211 9.29837 -0.000366211 9C-0.000366211 8.70163 0.11816 8.41548 0.329139 8.2045C0.540117 7.99353 0.826265 7.875 1.12463 7.875H7.87463V1.125C7.87463 0.826631 7.99316 0.540484 8.20414 0.329505C8.41512 0.118527 8.70127 0 8.99963 0Z",
    fill: "#1A1919"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAddSelectTree);
export default __webpack_public_path__ + "static/media/icon-add-select-tree.3e62d08226c913895deb6c824fa55d36.svg";
export { ForwardRef as ReactComponent };